import type { AnswerOption } from '@shared';

import { QuestionBodyMultiSelect } from './question-body-multi-select';
import { QuestionBodySingleSelect } from './question-body-single-select';

interface QuestionBodyMultiSelectWithPrimaryProps {
  options: AnswerOption[];
  primaryValue: string | null;
  secondaryValues: string[];
  primaryOtherText?: string;
  secondaryOtherText?: string;
  onPrimaryChange: (value: string) => void;
  onSecondaryChange: (values: string[]) => void;
  onPrimaryOtherTextChange?: (value: string) => void;
  onSecondaryOtherTextChange?: (value: string) => void;
  disabled?: boolean;
}

export function QuestionBodyMultiSelectWithPrimary({
  options,
  primaryValue,
  secondaryValues,
  primaryOtherText,
  secondaryOtherText,
  onPrimaryChange,
  onSecondaryChange,
  onPrimaryOtherTextChange,
  onSecondaryOtherTextChange,
  disabled,
}: QuestionBodyMultiSelectWithPrimaryProps) {
  const secondaryOptions = options.filter(o => o.value !== primaryValue);
  const sanitizedSecondary = secondaryValues.filter(v => v !== primaryValue);

  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <p className="text-foreground text-sm font-medium">Top goal</p>
        <QuestionBodySingleSelect
          options={options}
          value={primaryValue}
          onChange={onPrimaryChange}
          otherValue={primaryOtherText}
          onOtherValueChange={onPrimaryOtherTextChange}
          disabled={disabled}
        />
      </div>

      {primaryValue && (
        <div className="space-y-3">
          <p className="text-foreground text-sm font-medium">
            Anything else you care about?{' '}
            <span className="text-foreground font-normal">(optional)</span>
          </p>
          <QuestionBodyMultiSelect
            options={secondaryOptions}
            value={sanitizedSecondary}
            onChange={onSecondaryChange}
            otherValue={secondaryOtherText}
            onOtherValueChange={onSecondaryOtherTextChange}
            disabled={disabled}
          />
        </div>
      )}
    </div>
  );
}
